import React, { Fragment } from "react";
import './ReactComponent.scss';
import ResourcePupilUsageYearSummary from "./ResourcePupilUsageYearSummary";
import ResourceUsagePie from "./ResourceUsagePie";
import UsageYearSummary from "./UsageYearSummary";
import UsagePie from "./UsagePie";
import ResourcePupilUsageBySchool from "./ResourcePupilUsageBySchool";
import phpVars from 'phpVars';
import {UserTypeNames} from "../globals";
import S360WidgetContainer from "root/s360components/LearningJournal/S360WidgetContainer";


const UsageDashboard = (props) =>
{
    const dashboardRows = () =>
    {

        return (
            <Fragment>
                <S360WidgetContainer style={{margin: '10px'}}>
                    <div key='row1' className='row'>
                        <div className='col-md-6 padding-style'>
                            <ResourcePupilUsageYearSummary title='Resources - Pupil Access by Month'
                                                           school_id={props.school_id} resource_type='shared'/>
                        </div>

                        <div className='col-md-6 padding-style'>
                            <ResourceUsagePie key='row2-pie1' title='Resources - Pupil Access Totals'
                                              school_id={props.school_id} resource_type='shared'/>
                        </div>
                    </div>

                    <div key='row2' className='row'>
                        <div className='col-md-6 padding-sm'>
                            <UsageYearSummary title='School360 Access by Month' school_id={props.school_id}/>
                        </div>

                        <div className='col-md-6 padding-sm'>
                            <UsagePie key='row2-pie2' title='School360 Access Totals' school_id={props.school_id}/>
                        </div>
                        {/*
                        <div key='row2' className='row'>
                            <div className='col-md-6 padding-sm'>
                                {phpVars.user_type === UserTypeNames.USER_TYPE_NAME_ADMIN &&
                                    <ResourcePupilUsageBySchool title='Resources - Access All Schools'/>}
                            </div>
                            <div className='col-md-6 padding-sm'></div>
                        </div>
                        */}
                    </div>
                </S360WidgetContainer>
            </Fragment>
    )
    }

    return dashboardRows();
};

export default UsageDashboard;
